import React from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayFieldsController from "../../../../UI/modules/fieldsDisplay/ModuleDisplayFieldsController";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import memberDummyImage from "../../../../../images/memberDummyImage.jpg";
import memberStatusEmailVerificationRequired from "../../../../../images/memberStatusEmailVerificationRequired.png";
import memberStatusSignupRequest from "../../../../../images/memberStatusSignupRequest.png";
import memberStatusRejected from "../../../../../images/memberStatusRejected.png";
import memberStatusRegistrationPaymentPending from "../../../../../images/memberStatusRegistrationPaymentPending.png";
import memberStatusMember from "../../../../../images/memberStatusMember.jpg";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import {
  getCurrencyCode,
  getFullName,
} from "../../../../../helpers/CommonHelper";
import { GiMeal } from "react-icons/gi";
const Item = ({
  item,
  handleCheckBoxClick,
  isCheck,
  moduleConfig,
  confirmAndDelete,
  confirmAndDisabled,
  confirmAndEnabled,
  customButtonsForItems,
}) => {
  const fields = moduleConfig.fields;
  const getCustomerSubscriptions = () => {
    let items = [];

    if (item?.subscribedMeals && item?.subscribedMeals.length > 0) {
      // Add plan info
      if (item?.plan?.title) {
        items.push({
          text: "Plan",
          value: item.plan.title,
          type: "text",
        });
      }

      if (item?.subscribedMeals) {
        items.push({
          text: "Subscribed Meals",
          value: item?.subscribedMeals.length,
          type: "number",
        });
      }
      // Add subscription details
      items.push(
        {
          text: "Total Meals in Plan",
          value: item.totalMealsInPlan,
          type: "number",
        },

        {
          text: "Subscription Period",
          value: `${item.subscriptionStartDate} - ${item.subscriptionEndDate}`,
          type: "text",
        },

        {
          text: "Total Amount",
          value: item.totalAmount + " " + getCurrencyCode(),
          type: "text",
        },
      );
      if (item?.disclaimerAccepted) {
        items.push({
          text: "Disclaimer Accepted",
          value: item?.disclaimerAccepted,
          trueValue: "Yes",
          falseValue: "No",
          type: "boolean",
        });
      }
      // Add each subscribed meal
      // item.subscribedMeals.forEach((meal) => {
      //   items.push({
      //     text: `${meal.meal?.title}`,
      //     value: `AED ${meal.subscriptionActualAmount} × ${meal.chargedDays} days = AED ${meal.totalAmount}`,
      //   });
      // });
    }

    return items;
  };

  return (
    <Card className="item mb-2 borderCream">
      <Card.Header className="ps-1 pe-2 py-0">
        <Card.Title className="d-flex m-0 p-0">
          <div className="d-flex ImageSectionSpacing">
            <div className="ms-1 me-2">
              <GiMeal size={40} className="text-secondary" />
            </div>
            <div className="d-flex flex-column ms-1">
              <span className="m-0 text-bold memberName text-red">
                <Link
                  to={`/customers/${item?.customer?._id}`}
                  className="hoveredText"
                >
                  {item?.customer?.firstName} {item?.customer?.lastName}
                </Link>
              </span>

              <span className="text-custom-4 mt-1 small text-bold">
                {item?.kid?.firstName} {item?.kid?.lastName} ({item?.kid?.age}{" "}
                years)
              </span>
            </div>
          </div>
        </Card.Title>

        <div className="card-tools endColumn mb-1 pt-1">
          <div>
            {item.depositReturned === "1" && (
              <span
                className={`badge fw-semibold  rounded-pill shadow-sm me-1  px-2 bg-warning`}
              >
                Deposit Returned
              </span>
            )}
            {item.vegOrNonVeg && (
              <span
                className={`badge fw-semibold  rounded-pill shadow-sm me-1  px-2 ${
                  item.vegOrNonVeg.toLowerCase() === "veg"
                    ? "bg-success text-light"
                    : "bg-danger text-light"
                }`}
              >
                {item.vegOrNonVeg}
              </span>
            )}
            {item.status && (
              <span
                className={`badge fw-semibold rounded-pill shadow-sm me-1 px-2 ${
                  item.status === "Active"
                    ? "bg-info"
                    : item.status === "Paused"
                      ? "bg-warning text-dark"
                      : item.status === "Cancelled"
                        ? "bg-danger"
                        : item.status === "Expired"
                          ? "bg-dark"
                          : "bg-secondary"
                }`}
              >
                {item.status}
              </span>
            )}

            {item?.createdAt && (
              <span className="badge badge-light me-1 text-dark">
                Created Date :{" "}
                <span className="text-secondary">
                  <ModuleDisplayDate value={item?.createdAt} />{" "}
                </span>
              </span>
            )}
          </div>

          <div className=" text-right me-xl-2  mt-1">
            <Link
              to={`/${moduleConfig.url}/${item?._id}`}
              className="btn btn-outline-secondary  listingActionIcon"
              title={`View ${moduleConfig.singleItemTitle}`}
            >
              <i className="fas fa-eye"></i>
            </Link>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="px-1 py-0">
        <Row>
          <Col className="mt-1 mb-1 ">
            <StatsListing items={getCustomerSubscriptions()} />
            {/* <div className="d-flex">
               <StatsListing
                heading="Subscribed Meals"
                clickable={false}
                items={getCustomerSubscriptions()}
              />
              
            </div> */}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Item;
